module.exports = __webpack_public_path__ + "img/selected2-min.d4eab7dc.png";